// extracted by mini-css-extract-plugin
export default {"imgdiv":"_7c22d57ef9 bc067d3736","img":"f70ab9d5e2 _6961bfe69a"};